import React from 'react';
import { Leaf } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { formatPrice } from '../../lib/utils';

const COLORS = ['hsl(142, 60%, 40%)', 'hsl(199, 70%, 50%)', 'hsl(271, 50%, 50%)', 'hsl(25, 70%, 50%)', 'hsl(0, 70%, 55%)', 'hsl(130, 25%, 60%)'];

export const SalesCharts = ({ chartData, statusData }) => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8">
            {/* Revenue Chart */}
            <Card className="lg:col-span-2 border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl">
                <CardHeader>
                    <CardTitle className="font-heading text-jungle">Evolution des ventes</CardTitle>
                </CardHeader>
                <CardContent>
                    {chartData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={chartData}>
                                <CartesianGrid strokeDasharray="3 3" stroke="hsl(150 15% 85%)" />
                                <XAxis dataKey="month" stroke="hsl(150 20% 40%)" fontSize={12} />
                                <YAxis stroke="hsl(150 20% 40%)" fontSize={12} />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: 'rgba(255,255,255,0.95)',
                                        border: '1px solid hsl(150 15% 85%)',
                                        borderRadius: '12px'
                                    }}
                                    formatter={(value, name) => [
                                        name === 'revenue' ? formatPrice(value) : value,
                                        name === 'revenue' ? 'CA' : 'Commandes'
                                    ]}
                                />
                                <Bar dataKey="revenue" fill="hsl(142, 60%, 40%)" radius={[8, 8, 0, 0]} />
                            </BarChart>
                        </ResponsiveContainer>
                    ) : (
                        <div className="h-[300px] flex items-center justify-center text-muted-foreground">
                            <div className="text-center">
                                <Leaf className="w-12 h-12 mx-auto mb-4 text-jungle/20" />
                                <p>Pas encore de donnees</p>
                            </div>
                        </div>
                    )}
                </CardContent>
            </Card>

            {/* Status Pie Chart */}
            <Card className="border-0 bg-white/80 backdrop-blur-sm shadow-sm rounded-2xl">
                <CardHeader>
                    <CardTitle className="font-heading text-jungle">Statuts des commandes</CardTitle>
                </CardHeader>
                <CardContent>
                    {statusData.length > 0 ? (
                        <ResponsiveContainer width="100%" height={300}>
                            <PieChart>
                                <Pie
                                    data={statusData}
                                    cx="50%"
                                    cy="50%"
                                    innerRadius={60}
                                    outerRadius={100}
                                    paddingAngle={2}
                                    dataKey="value"
                                >
                                    {statusData.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>
                        </ResponsiveContainer>
                    ) : (
                        <div className="h-[300px] flex items-center justify-center text-muted-foreground">
                            Pas de donnees
                        </div>
                    )}
                    <div className="flex flex-wrap gap-2 justify-center mt-4">
                        {statusData.map((entry, index) => (
                            <div key={entry.name} className="flex items-center gap-1 text-xs">
                                <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }} />
                                <span className="text-jungle/70">{entry.name}</span>
                            </div>
                        ))}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};
